export default "__VITE_ASSET__DJP8Pfjn__"